const HISTORICAL_URLS_LOCAL_STORAGE_KEY = 'CUCS:HostoricalUrls';

export default HISTORICAL_URLS_LOCAL_STORAGE_KEY;